<template>
  <div>
    <v-row no-gutters>
      <span class="body-2 font-weight-medium">Your Details</span>
    </v-row>

    <div>
      <v-row>
        <v-col cols="2">
          <span class="caption">Title</span>
          <v-select outlined dense
                    v-model="fields.title"
                    :items="titles"
                    :error-messages="isTitleValid"
                    :menu-props="{ overflowY: true, offsetY: true, closeOnContentClick: true }"
          >

          </v-select>
        </v-col>
        <v-col>
          <span class="caption">Forename</span>
          <v-text-field outlined dense
                        v-model="fields.forename"
                        :error-messages="isForenameValid"
          ></v-text-field>
        </v-col>
        <v-col>
          <span class="caption">Surname</span>
          <v-text-field outlined dense
                        v-model="fields.surname"
                        :error-messages="isSurnameValid"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="mt-n6">
        <v-col>
          <span class="caption">My position within the Council</span>
          <v-select outlined dense
                    v-model="fields.position"
                    :items="positions"
                    :error-messages="isPositionValid"
                    :menu-props="{ overflowY: true, offsetY: true, closeOnContentClick: true }"
          ></v-select>
        </v-col>
      </v-row>

      <v-row no-gutters class="mt-n4 pl-4">
        <v-checkbox v-model="fields.confirmation"
                    color="info"
                    label="I confirm that I am authorised to subscribe on behalf of the Local Council"
                    :error-messages="isConfirmationValid"
        ></v-checkbox>
      </v-row>
    </div>

    <v-row no-gutters class="mt-2">
      <span v-if="isAllValid" class="body-2">Click "Next" to continue the signup process.</span>
      <span v-else class="body-2 font-weight-medium" style="color: #BF1722">Please complete all required fields.</span>
    </v-row>

  </div>
</template>

<script>
  export default {
    name: "StepFour",
    components: {},
    props: {
      valid: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        fields: {
          title: '',
          forename: '',
          surname: '',
          position: '',
          confirmation: false,
        },
        fieldsError: {
          title: false,
          forename: false,
          surname: false,
          position: false,
          confirmation: false,
        },
        titles: ['Mr', 'Mrs', 'Mr', 'Miss', 'Mx', 'Dr', 'Sir', 'Lady', 'Cllr', 'Reverend', 'Rt. Hon.'],
        positions: ["Clerk", "Office Staff with permission from the Clerk", "Elected Councillor with permission from the Clerk", "Consultant with permission from the Clerk", "Other"]
      }
    },
    computed: {
      isTitleValid() {
        let title = this.fields.title;
        let messages = [];
        if (title === '') {
          this.fieldsError.title = true;
        } else {
          this.fieldsError.title = false;
          messages = [];
        }
        return messages;
      },
      isForenameValid() {
        let forename = this.fields.forename;
        let regex = /^[a-zA-Z]+$/;
        let messages = [];
        if (forename === '') {
          this.fieldsError.forename = true;
        } else if (!regex.test(forename)) {
          this.fieldsError.forename = true;
          messages.push('Invalid input.');
        } else {
          this.fieldsError.forename = false;
          messages = [];
        }
        return messages;
      },
      isSurnameValid() {
        let surname = this.fields.surname;
        let regex = /^[a-zA-Z]+$/;
        let messages = [];
        if (surname === '') {
          this.fieldsError.surname = true;
        } else if (!regex.test(surname)) {
          this.fieldsError.surname = true;
          messages.push('Invalid input.');
        } else {
          this.fieldsError.surname = false;
          messages = [];
        }
        return messages;
      },
      isPositionValid() {
        let position = this.fields.position;
        let messages = [];
        if (position === '') {
          this.fieldsError.position = true;
        } else {
          this.fieldsError.position = false;
          messages = [];
        }
        return messages;
      },
      isConfirmationValid() {
        let confirmation = this.fields.confirmation;
        let messages = [];
        if (confirmation === false) {
          this.fieldsError.confirmation = true;
        } else {
          this.fieldsError.confirmation = false;
          messages = [];
        }
        return messages;
      },
      isAllValid() {
        let valid = !this.fieldsError.title && !this.fieldsError.forename && !this.fieldsError.surname && !this.fieldsError.position && !this.fieldsError.confirmation;
        this.$emit('update:valid', valid);
        if (valid) {
          this.$store.commit('SET_PERSONAL_DETAILS', this.fields);
        }
        return valid;
      },
    },
    methods: {

    }
  }
</script>
